export const conditionsMet = (conditions, attributes) => {
    const keys = Object.keys(conditions);
    for (let i = 0; i < keys.length; i++) {
        const currentKey = keys[i];
        if (!Object.prototype.hasOwnProperty.call(attributes, currentKey)) {
            return false;
        }
        const attribute = attributes[currentKey];
        const condition = conditions[currentKey];
        if (Array.isArray(attribute) && !attribute.includes(condition)) {
            return false;
        }
        if (!Array.isArray(attribute) && attribute !== condition) {
            return false;
        }
    }
    return true;
};
//# sourceMappingURL=conditions-met.js.map